export function resolveApiBaseURL(): string {
    const fallback = process.env.REACT_APP_API_HOST || "";
    if (typeof window === "undefined" || !window.location) return fallback;

    const { hostname } = window.location;

    const hostNoPort = hostname.split(":")[0].toLowerCase();
    const labels = hostNoPort.split(".");

    // Require at least <sub>.<domain>.<tld>
    if (labels.length < 3) return fallback;

    const tld = labels.slice(-2).join(".");
    const tenantLabel = labels[0];

    const isStrongMSP = tld === "strongmindstrongperformance.com";
    const isLocalTenant = tenantLabel === "localhost" || (labels.length >= 4 && labels[1] === "local");
    const isStagingTenant = labels.length >= 4 && labels[1] === "stage";

    // Use shared API endpoints per environment (no per-tenant API subdomains)
    if (isStrongMSP) {
        if (isLocalTenant) {
            // Local dev shared API host (supports port)
            return process.env.REACT_APP_API_HOST || "localapi.strongmindstrongperformance.com:8088";
        }
        if (isStagingTenant) {
            // Staging shared API host
            return process.env.REACT_APP_API_HOST_STAGE || "api.stage.strongmindstrongperformance.com";
        }
        // Prod shared API host
        return process.env.REACT_APP_API_HOST || "api.strongmindstrongperformance.com";
    }

    return fallback;
}


